import { render, staticRenderFns } from "./WameedVerificationInput.vue?vue&type=template&id=08de8a1e&"
import script from "./WameedVerificationInput.vue?vue&type=script&lang=js&"
export * from "./WameedVerificationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports